import React from 'react';
import { componentService } from 'js/services/component.service';

export const SendVerificationEmail = React.lazy(() => import(/* webpackChunkName: "send-verification-email" */ './SendVerificationEmail'));

componentService.registerPageComponents({ sendverificationemail: SendVerificationEmail });
